import { Contract, ContractDetails as TContractDetails } from 'cpfr-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchContracts } from './ContractsSlice';
import { ContractsDataSelector } from './ContractsDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useContracts(): AbstractDataState<
    Array<Contract & TContractDetails>,
    DefaultBusinessMarketApiErrorCode
> {
    return useGetSimpleApiData(fetchContracts, ContractsDataSelector);
}
